export const DOCUMENT_TYPE_SHOW_RESET = 'DOCUMENT_TYPE_SHOW_RESET'
export const DOCUMENT_TYPE_SHOW_SET_ERROR = 'DOCUMENT_TYPE_SHOW_SET_ERROR'
export const DOCUMENT_TYPE_SHOW_SET_RETRIEVED = 'DOCUMENT_TYPE_SHOW_SET_RETRIEVED'
export const DOCUMENT_TYPE_SHOW_TOGGLE_LOADING = 'DOCUMENT_TYPE_SHOW_TOGGLE_LOADING'
